import script from "./WarehousesList.vue?vue&type=script&setup=true&lang=js"
export * from "./WarehousesList.vue?vue&type=script&setup=true&lang=js"

import "./WarehousesList.vue?vue&type=style&index=0&id=df93a4c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df93a4c4"]])

export default __exports__